import HtmlParser from "react-html-parser";

export default class {
    static getUnitName(units) {
        switch (units) {
            case "degC":
                return HtmlParser("&deg;C");
            case "perc":
            case "Percent":
            case "%":
                return "%";
            case "co2":
            case "CO2":
                return HtmlParser("CO<sub>2</sub>");
            case "status":
            case "count":
                return "";
            default:
                return units || "";
        }
    }

    static stringToSymbol(str){
        if(typeof str !== "string"){
            return str;
        }
        
        switch (str.toLowerCase()) {
            case "count":
            case "insession":
            case "status":
            case "minutes":
                return "";
            case "degc":
                return "°C";
            case "percent":
                return "%";
            default:
                return str;
        }
    }

    static stringToDecimalPlaces(str) {
        if (typeof str !== "string") {
            return 0;
        }

        switch (str.toLowerCase()) {
            case "count":
            case "insession":
            case "status":
            case "minutes":
                return 0;
            case "degc":
                return 1;
            case "percent":
                return 2;
            default:
                return 2;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/units.js